function switchTab(tabIndex) {
    // 移除所有active类
    document.querySelectorAll('.dl-collection-tabs__tab').forEach(tab => {
        tab.classList.remove('active');
    });
    document.querySelectorAll('.dl-collection-tabs__content').forEach(content => {
        content.classList.remove('active');
    });

    // 添加active类到选中的tab
    document.querySelector(`[data-tab="${tabIndex}"]`).classList.add('active');
    document.querySelector(`[data-tab="${tabIndex}"]`).scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
    });
    document.querySelector(`[data-tab-content="${tabIndex}"]`).classList.add('active');
}

